<template>
  <div class="edit-tag">
    <h3>QUICK EDIT</h3>
    <div class="input-wrap">
      <span> Name </span>
      <input type="text" v-model="name" />
    </div>
    <div class="controls">
      <a-button
        @click="cancelEdit"
        style="
        margin-right: 10px
          background: #ffffff !important;
          border: 1px solid #dfe1e6;
          box-sizing: border-box;
          border-radius: 2px;
          font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 24px;
            color: #001529;
        "
      >
        Cancel
      </a-button>
      <a-button
      @click="updateTag"
        style="
          background: #2295d6;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 22px;
          display: flex;
          align-items: center;
          justfy-content: center;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 22px;
          color: #ffffff;
        "
      >
        Update tag
      </a-button>
    </div>
  </div>
</template>

<script>
import api from '@/api'
export default {
  props: {
    tagData: {
      type: Object,
    },
  },
  data(){
      return {
          name:this.tagData.name
      }
  },
  methods: {
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    async updateTag() {
      let obj = {
        tag_name: this.name,
        tag_id: this.tagData.id,
      };
      try {
        const res = await api.patchTag(obj)
        this.$emit("cancelEdit");
      } catch (error) {
          console.log(error);
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.edit-tag {
  height: 180px;
  background: #f4f5f7;
  padding: 17px 10px;
  h3 {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    color: #b2bac7;
  }
  .input-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 23px 0 0 50px;
    span {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      display: flex;
      align-items: center;
      color: #001529;
      margin: 0 10px 0 0;
    }
    input {
      height: 32px;
      background: #ffffff;
      border: 1px solid #dfe1e6;
      box-sizing: border-box;
      border-radius: 2px;
    }
  }
  .controls {
    margin: 30px 0 0 0;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
}
</style>